import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { SchirmerTearTestRightEyeAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-schirmer-tear-test-right-eye-slot',
    templateUrl: './schirmer-tear-test-right-eye-slot.component.html',
    styleUrl: './schirmer-tear-test-right-eye-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchirmerTearTestRightEyeSlotComponent implements SheetSlotComponentBase {

	action!: SchirmerTearTestRightEyeAction;
	value!: string | null;

	@Input('action') set updateAction(action: SchirmerTearTestRightEyeAction | null) {
		this.action = action as SchirmerTearTestRightEyeAction;
		this.value = this.action.eye?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}